import React from 'react';
import PropTypes from 'prop-types';
import {Form} from '@evag/ec-react';
import '@evag/ec-react/dist/main.css';

import Basic from 'src/components/forms/parts/Basic';
import Material from 'src/components/forms/parts/Material';
import Feedback from 'src/components/forms/parts/Feedback';

// Some props, like 'initialValues', should be merged with the default component values, instead of replacing them.
const merge = (comp, props) => {
  const merged = {...comp, ...props};
  for (let key of ['initialValues']) {
    merged[key] = {...comp[key], ...props[key]};
  }
  return merged;
};

// A basic generic form with feedback after submit.
// If basic.showMateriais is true displays a material form after submit, and feedback after material submit.
const FormBasic = ({basic, feedback}) => {
  const b = merge(Basic, basic);
  const f = typeof feedback === 'string' ? feedback : merge(Feedback, feedback);
  let forms = [b, f];

  if (b.showMateriais) {
    b.onSuccess = ({jump, values}) => jump(values.material ? 1 : 2, values);
    forms = [b, Material, f];
  }

  return <Form forms={forms} />;
};

FormBasic.propTypes = {
  basic: PropTypes.object.isRequired,
  feedback: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
};

export default FormBasic;
